import {
  FluidAddressFields,
  FluidFieldTranslations,
  FluidLanguage,
  FluidTranslationSet,
} from '@lmig/fluid-core';

export const usAddressTranslations: FluidTranslationSet<
  FluidFieldTranslations<FluidAddressFields>
> = {
  [FluidLanguage.ENGLISH]: {
    addressTitle: {
      label: 'Address',
    },
    addressLineOne: {
      label: 'Address Line 1',
      validation: {
        required: 'This field is required',
      },
    },
    addressLineTwo: {
      label: 'Address line 2',
    },
    country: {
      label: 'Country',
    },
    townOrCity: {
      label: 'Town/City',
    },
    countyOrProvince: {
      label: 'State',
    },
    postOrZipCode: {
      label: 'Zip Code',
      validation: {
        required:
          'You must enter a zip code otherwise the form will be very, very much invalid! Is this long enough? Who knows.',
        pattern: 'You must enter a valid US zipcode.',
      },
    },
    regionOrLocality: {
      label: 'Region',
    },
  },
};
